var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"app":"","color":"#FAFAFA","flat":""}},[_c('v-spacer'),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.organizationName && _vm.userName),expression:"organizationName && userName"}]},[_vm._v(" ようこそ "+_vm._s(_vm.organizationName)+" "+_vm._s(_vm.userName)+"様 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }